import React from 'react';
import styles from '../styles';
import MedicalPassportField from '../components/MedicalPassportField';
import MedicalPassportCheckbox from '../components/MedicalPassportCheckbox';
import MedicalPassportTextArea from '../components/MedicalPassportTextArea';
import getAgeAndBmi from './pageUtils';
import {
  cardiovascular,
  endocrine,
  gastrointestinal,
  hepatic,
  infectious,
  musculoskeletal,
  neurological,
  oncologic,
  pain,
  psychiatric,
  pulmonary,
  renal,
  vascular,
} from './paths';
import toAge from '../../../../../questionnaire/toAge';
import toSex from '../../../../../questionnaire/toSex';
import toHighlightsString from '../../../../../questionnaire/toHighlightsString';
import toHeight from '../../../../../questionnaire/toHeight';
import toWeight from '../../../../../questionnaire/toWeight';
import toBMI from '../../../../../questionnaire/toBMI';
import get from 'lodash/get';
import { useValue } from '../ValueContext';
import Barcode from '../../Barcode';
import toHighlightsString4 from '../../../../../questionnaire/toHighlightsString4';
import { getcontent } from '../golfCoast/pages/contentlimit';
import MedicalPassportTextArea2 from '../components/MedicalPassportTextArea2';
import toStringWithoutQuestions3 from '../../../../../questionnaire/toStringWithoutQuestions3';
export const MedicalPassportCheckboxStyledWrapper = ({ children, borderLeft }) => (
  <div
    style={{
      borderLeft: borderLeft ? borderLeft : '1px solid black',
      padding: '1px 0 0 20px',
    }}
  >
    {children}
  </div>
);

export const ReviewofSystemWrapper = ({ label, value }) => (
  <div
    style={{
      lineHeight: '12px',
      borderLeft: 0,
      borderRight: 0,
      borderTop: 0,
    }}
  >
    <div style={styles.systemrow2}>
      <div
        style={{
          borderRight: '1px solid black',
          paddingLeft: '5px',
          paddingTop: '3px',
          fontSize: '12px',
        }}
      >
        {label}
      </div>
      <div
        style={{
          display: 'flex',
          padding: '1px',
        }}
      >
        <MedicalPassportTextArea2
          value={value}
          style={{ width: '100%', minHeight: '33px' }}
          fontSize={'11px'}
          nobackground
          placeholder={'No'}
        />
      </div>
    </div>
  </div>
);
const CommonSubPartOneOriginalVariant = () => (
  <div>
    <div>Anesthetic Plan:</div>
    <div style={{ lineHeight: '12px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <MedicalPassportCheckbox name="page4.anestheticPlan.ga" label="GA" />
        <MedicalPassportCheckbox name="page4.anestheticPlan.mac" label="MAC" />
        <MedicalPassportCheckbox name="page4.anestheticPlan.moderateSedation" label="Moderate Sedation" />
        <MedicalPassportCheckbox name="page4.anestheticPlan.regionalBlock" label="Regional Block" />
      </div>
      <div>
        <MedicalPassportCheckbox name="page4.anestheticPlan.sab" label="SAB" />
        <MedicalPassportCheckbox name="page4.anestheticPlan.pnb" label="PNB" />
        <MedicalPassportCheckbox name="page4.assessment2.other" />
        <MedicalPassportField name="page4.assessment2.otherText" label="Other" />
      </div>
    </div>
  </div>
);

const CommonSubPartOneAlteredVariant = () => (
  <div style={{ lineHeight: '12px' }}>
    <div style={{ display: 'flex' }}>
      <div style={{ paddingTop: '3px' }}>Anesthetic Plan:</div>
      <MedicalPassportCheckbox name="page4.anestheticPlan.ga" label="GA" />
      <MedicalPassportCheckbox name="page4.anestheticPlan.mac" label="MAC" />
      <MedicalPassportCheckbox name="page4.anestheticPlan.sab" label="SAB" />
      <MedicalPassportCheckbox name="page4.anestheticPlan.pnb" label="PNB" />
      <div style={{ width: '25%' }}></div>
    </div>
    <div style={{ display: 'flex' }}>
      <MedicalPassportCheckbox name="page4.anestheticPlan.moderateSedation" label="Moderate Sedation" />
      <MedicalPassportCheckbox name="page4.anestheticPlan.regionalBlock" label="Regional Block" />
      <MedicalPassportCheckbox name="page4.assessment2.other" />
      <MedicalPassportField name="page4.assessment2.otherText" label="Other" fontSize={9} />
    </div>
  </div>
);

const CommonPartOne = ({ variant }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: '50% 50%',
      fontSize: '9px',
    }}
  >
    <div style={{ border: '1px solid black', padding: '5px', borderRight: 0 }}>
      <div style={{ display: 'flex', gap: '30px' }}>
        <div>ASA Class:</div>
        <MedicalPassportCheckbox label="1" name="page4.asaClass1" />
        <MedicalPassportCheckbox label="2" name="page4.asaClass2" />
        <MedicalPassportCheckbox label="3" name="page4.asaClass3" />
        <MedicalPassportCheckbox label="4" name="page4.asaClass4" />
      </div>
      <div style={{ lineHeight: '11px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '4fr 1fr 1fr' }}>
          <div>NPO Status Verified?</div>
          <div>
            <MedicalPassportCheckbox name="page4.NPOStatusVerifiedYes" label="Yes" />
          </div>
          <div>
            <MedicalPassportCheckbox name="page4.NPOStatusVerifiedNo" label="No" />
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '4fr 1fr 1fr' }}>
          <div>Pt. Reassessed Day of Surgery?</div>
          <div>
            <MedicalPassportCheckbox name="page4.reassuredDayOfSurgeryYes" label="Yes" />
          </div>
          <div>
            <MedicalPassportCheckbox name="page4.reassuredDayOfSurgeryNo" label="No" />
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '4fr 2fr' }}>
          <div>Postoperative Plan:</div>
          <div>
            <MedicalPassportCheckbox name="page4.pacu" label="PACU/Home" />
          </div>
        </div>
      </div>
    </div>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        border: '1px solid black',
        padding: '2px',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>Assessment:</div>
        <div style={{ lineHeight: '12px' }}>
          <MedicalPassportCheckbox name="page4.noContradictionAnesthesia" label="No contradiction to anesthesia" />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <MedicalPassportCheckbox name="page4.assessment1.other" />
            <MedicalPassportField name="page4.assessment1.otherText" label="Other" fontSize={11} />
          </div>
        </div>
      </div>
      {variant === 'original' ? <CommonSubPartOneOriginalVariant /> : <CommonSubPartOneAlteredVariant />}
    </div>
  </div>
);

const Page4 = ({ formName, pageNumber, showQRCode, hospitalName, value, defaultValue }) => {
  const providerId = defaultValue?.procedure?.patient?.providerId;
  const { age, bmi } = getAgeAndBmi(
    defaultValue?.demographicInformation?.dob,
    defaultValue?.demographicInformation?.bmi
  );
  const { questionnaireAnswers } = useValue();
  const drinking = get(
    questionnaireAnswers,
    'sections.Psychiatric.schema.psychiatric_list.checkboxes["Drink beer, wine or liquor"]',
    false
  );
  const drugs = get(
    questionnaireAnswers,
    'sections.Psychiatric.schema.psychiatric_list.checkboxes["History of using recreational or street drugs"]',
    false
  );
  const smoking = get(questionnaireAnswers, 'sections.basicscreening.schema["smoking status"].option[0]', '');
  const isSmoking = smoking === '' || smoking === 'N' ? false : true;

  const allergy = getcontent(toHighlightsString, [['allergies']], 120);
  const surgery = getcontent(toHighlightsString, [['priorSurgeries']], 120);
  const anesthesia = getcontent(toHighlightsString4, [['anesthesia complications']], 120);
  const medication = getcontent(toHighlightsString, [['medications']], 120);

  const cardiacList = getcontent(toStringWithoutQuestions3, cardiovascular, 200);
  const endocrineList = getcontent(toStringWithoutQuestions3, endocrine, 200);
  const GIList = getcontent(toStringWithoutQuestions3, gastrointestinal, 200);
  const hepaticList = getcontent(toStringWithoutQuestions3, hepatic, 200);
  const infectiousList = getcontent(toStringWithoutQuestions3, infectious, 200);
  const musculoskeletalList = getcontent(toStringWithoutQuestions3, musculoskeletal, 200);
  const neurologicalList = getcontent(toStringWithoutQuestions3, neurological, 200);
  const oncologicList = getcontent(toStringWithoutQuestions3, oncologic, 200);
  const painList = getcontent(toStringWithoutQuestions3, pain, 200);
  const psychiatricList = getcontent(toStringWithoutQuestions3, psychiatric, 200);
  const pulmonaryList = getcontent(toStringWithoutQuestions3, pulmonary, 200);
  const renalList = getcontent(toStringWithoutQuestions3, renal, 200);
  const vascularList = getcontent(toStringWithoutQuestions3, vascular, 200);

  return (
    <div id="page4" className="page" style={{ fontSize: '11px', fontFamily: 'Arial' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1px' }}>
          <h2>ANESTHESIA ASSESSMENT</h2>
          <div>{hospitalName || ''}</div>
        </div>
        <div>
          {showQRCode && (
            <Barcode
              formName={formName}
              pageNumber={pageNumber}
              providerId={defaultValue?.procedure?.patient?.providerId}
              serviceTime={defaultValue?.procedure?.serviceTime}
            />
          )}
        </div>
      </div>
      <div style={{ border: '1px solid black', borderBottom: 0, borderLeft: 0 }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '55% 45%',
            borderBottom: '1px solid black',
          }}
        >
          <div>
            <div
              style={{
                border: '1px solid black',
                borderTop: 0,
                minHeight: '60px',
                height: '100%',
                padding: '1px 2px 0 0',
                borderBottom: '0px',
              }}
            >
              <div
                style={{
                  paddingBottom: '35px',
                }}
              >
                <MedicalPassportTextArea name="procedure.name" label="Procedure" fontSize={14} />
              </div>
              <div
                style={{
                  border: '1px solid black',
                  padding: '0.2rem 0.1rem 0 0',
                  borderBottom: 0,
                  borderRight: 0,
                  borderLeft: 0,
                }}
              >
                <MedicalPassportField
                  name="page4.activityLevel"
                  label="Activity Level"
                  path={['basicscreening', 'level of physical activity']}
                  reducer={toHighlightsString}
                  fontSize={12}
                />
              </div>
            </div>
          </div>
          <div>
            <div style={{ bottom: '5px', paddingLeft: '3px' }}>
              <div style={{ marginBottom: '2px' }}>
                <MedicalPassportField name="procedure.patient.name" label="Patient" fontWeight={'bold'} fontSize={14} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '2px' }}>
                <MedicalPassportField name="dob" label="DOB" path={['demographicInformation', 'dob']} fontSize={11} />
                <MedicalPassportField name="procedure.serviceTime" label="DOS" fontWeight={700} fontSize={11} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '2px' }}>
                <MedicalPassportField name="procedure.patient.providerId" label="MRN#" fontSize={11} />
                <MedicalPassportField name="procedure.physician.name" label="Surgeon" fontSize={11} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '2px', paddingBottom: '1px' }}>
                <MedicalPassportField
                  name="age"
                  label="Age"
                  path={['demographicInformation', 'dob']}
                  reducer={toAge}
                  warning={age > 70}
                  fontSize={11}
                />
                <MedicalPassportField
                  name="sex"
                  label="Sex"
                  path={['demographicInformation', 'sex']}
                  reducer={toSex}
                  fontSize={11}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '2px', paddingBottom: '1px' }}>
                <MedicalPassportField
                  name="cardiologist"
                  label="Cardiologist"
                  path={['demographicInformation', 'cardiologist']}
                  fontSize={11}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '2px', paddingBottom: '1px' }}>
                <MedicalPassportField
                  name="procedure.pcp"
                  path={['demographicInformation', 'primaryCareDoctor']}
                  label="PCP"
                  fontSize={11}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            borderLeft: '1px solid black',
            borderBottom: '1px solid black',
          }}
        >
          <MedicalPassportTextArea2
            label="Med Allergies/Sensitivities"
            name="allergies1"
            value={allergy}
            warning={true}
            fontSize={10}
          />
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(6, 1fr)',
            borderLeft: '1px solid black',
            height: '20px',
          }}
        >
          <MedicalPassportCheckboxStyledWrapper
            borderLeft={'0'}
            children={
              <div>
                <input type="checkbox" checked={isSmoking} id="Smoking Hx" name="page3.smoking" />
                <label htmlFor="Smoking Hx">Smoking Hx</label>
              </div>
            }
          />
          <MedicalPassportCheckboxStyledWrapper
            children={
              <div>
                <input type="checkbox" id="etohCheckbox" checked={drinking} />
                <label htmlFor="etohCheckbox">ETOH Hx</label>
              </div>
            }
          />
          <MedicalPassportCheckboxStyledWrapper
            children={
              <div>
                <input type="checkbox" id="drugCheckbox" checked={drugs} />
                <label htmlFor="drugCheckbox">Drug Hx</label>
              </div>
            }
          />
          <MedicalPassportCheckboxStyledWrapper
            children={
              <MedicalPassportField
                name="ht"
                label="Ht"
                path={['demographicInformation', 'bmi']}
                reducer={toHeight}
                fontSize={10}
              />
            }
          />
          <MedicalPassportCheckboxStyledWrapper
            children={
              <MedicalPassportField
                name="wt"
                label="Wt"
                path={['demographicInformation', 'bmi']}
                reducer={toWeight}
                fontSize={10}
              />
            }
          />
          <MedicalPassportCheckboxStyledWrapper
            children={
              <MedicalPassportField
                name="bmi"
                label="BMI"
                path={['demographicInformation', 'bmi']}
                reducer={toBMI}
                warning={bmi !== '-' ? bmi > 40 : false}
                fontSize={10}
              />
            }
          />
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            fontSize: '12px',
          }}
        >
          <div style={styles.medicationsInnerDiv}>
            <MedicalPassportTextArea2
              label="Current Medications"
              name="medications1"
              value={medication}
              fontSize={10}
            />
          </div>
          <div style={{ ...styles.medicationsInnerDiv }}>
            <MedicalPassportTextArea2
              label="Surgical/Anesthesia Hx"
              name="anesthesia1"
              f
              value={surgery}
              fontSize={10}
            />
          </div>
        </div>
      </div>
      <div style={{ borderLeft: '1px solid black', borderRight: '1px solid black', fontSize: '12px' }}>
        <MedicalPassportTextArea2
          label={'Hx of Anesthesia Complications'}
          name="page4.hxAnesthesiaComplications"
          value={anesthesia}
          fontSize={12}
        />
      </div>

      <section style={{ breakInside: 'avoid' }}>
        <div style={styles.greyBackground}>
          <div>Review of Systems</div>
        </div>
        <ReviewofSystemWrapper label="Cardiovascular" value={cardiacList} />
        <ReviewofSystemWrapper label="Pulmonary" value={pulmonaryList} />
        <ReviewofSystemWrapper label="Genitourinary" value={renalList} />
        <ReviewofSystemWrapper label="Hepatic" value={hepaticList} />
        <ReviewofSystemWrapper label="Neurological" value={neurologicalList} />
        <ReviewofSystemWrapper label="Gastrointestinal" value={GIList} />
        <ReviewofSystemWrapper label="Vascular" value={vascularList} />
        <ReviewofSystemWrapper label="Endocrine/Metabolic" value={endocrineList} />
        <ReviewofSystemWrapper label="Musculoskeletal" value={musculoskeletalList} />
        <ReviewofSystemWrapper label="Psychiatric" value={psychiatricList} />
        <ReviewofSystemWrapper label="Oncology" value={oncologicList} />
        <ReviewofSystemWrapper label="Infectious Disease" value={infectiousList} />
        <ReviewofSystemWrapper label="Other" value={painList} />
      </section>
      <section style={{ breakInside: 'avoid' }}>
        <div style={styles.greyBackground}>Physical Exam/Labs/Anesthesia Plan</div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            borderLeft: '1px solid black',
            borderRight: '1px solid black',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '0.6fr 1fr 1fr 1fr 1fr 1fr 1fr',
              fontSize: '9px',
            }}
          >
            <div style={{ paddingLeft: '3px', paddingTop: '1px' }}>Vital Signs</div>
            <MedicalPassportField name="page4.temp" label="Temp" fontSize={11} />
            <MedicalPassportField name="page4.bp" label="BP" fontSize={11} />
            <MedicalPassportField name="page4.pulse" label="Pulse" fontSize={11} />
            <MedicalPassportField name="page4.resp" label="Resp" fontSize={11} />
            <MedicalPassportField name="page4.o2Sat" label="O2Sat" fontSize={11} />
            <MedicalPassportField name="page4.giu" label="GLU" fontSize={11} />
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6,1fr)', fontSize: '9px' }}>
          <div style={{ border: '1px solid black', borderRight: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '2px' }}>
              <div>General</div>
              <MedicalPassportCheckbox
                name="page4.generalWnl"
                label="WNL"
                style={{ display: 'flex', alignItems: 'center' }}
              />
            </div>
            <br />
            <br />
          </div>
          <div style={{ border: '1px solid black', borderRight: 0 }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: '0',
                fontSize: '9px',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '2px' }}>
                <div>Heart</div>
                <MedicalPassportCheckbox
                  name="page4.heartWnl"
                  label="WNL"
                  style={{ display: 'flex', alignItems: 'center' }}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <MedicalPassportCheckbox
                  name="page4.heartRegularRateRhythm"
                  label="Regular Rate + Rhythm"
                  style={{ display: 'flex' }}
                />
              </div>
            </div>
          </div>
          <div style={{ border: '1px solid black', borderRight: 0, fontSize: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '2px' }}>
              <div>Lungs</div>
              <div>
                <MedicalPassportCheckbox
                  name="page4.lungsWnl"
                  label="WNL"
                  style={{ display: 'flex', alignItems: 'center' }}
                />
                <MedicalPassportCheckbox
                  name="page4.lungsCta"
                  label="CTA"
                  style={{ display: 'flex', alignItems: 'center' }}
                />
              </div>
            </div>
          </div>
          <div style={{ border: '1px solid black', borderRight: 0 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '2px' }}>
              <div>Teeth</div>
              <MedicalPassportCheckbox
                name="page4.teethWnl"
                label="WNL"
                style={{ display: 'flex', alignItems: 'center' }}
              />
            </div>
          </div>
          <div style={{ border: '1px solid black', padding: '2px 2px', paddingBottom: '9px' }}>Airway Assessment:</div>
          <div
            style={{
              border: '1px solid black',
              borderLeft: 0,
              padding: '2px',
            }}
          >
            <div>Other</div>
          </div>
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3,1fr)',
            border: '1px solid black',
            borderBottom: 0,
            borderTop: 0,
            fontSize: '9px',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '1px' }}>
            <div>Labs reviewed</div>
            <MedicalPassportCheckbox
              name="page4.labYes"
              label="Yes"
              style={{ display: 'flex', alignItems: 'center' }}
            />
            <MedicalPassportCheckbox name="page4.labNo" label="N/A" style={{ display: 'flex', alignItems: 'center' }} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '2px' }}>
            <div>EKG/ECHO reviewed</div>
            <MedicalPassportCheckbox
              name="page4.ekgYes"
              label="Yes"
              style={{ display: 'flex', alignItems: 'center' }}
            />
            <MedicalPassportCheckbox name="page4.ekgNo" label="N/A" style={{ display: 'flex', alignItems: 'center' }} />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '2px' }}>
            <div>HCG</div>
            <MedicalPassportCheckbox
              name="page4.pregnantYes"
              label="Neg"
              style={{ display: 'flex', alignItems: 'center' }}
            />
            <MedicalPassportCheckbox
              name="page4.pregnantNo"
              label="N/A"
              style={{ display: 'flex', alignItems: 'center' }}
            />
          </div>
        </div>

        <CommonPartOne variant={'altered'} />
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
          <div style={{ textAlign: 'center' }}>
            <div>________________________________</div>
            <div>Anesthesia</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div>________________________________</div>
            <div>Date/Time</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Page4;
